export const actionType = {
  GET_VARIETIES_LIST_START: 'VARIETIES/GET_VARIETIES_LIST_START',
  GET_VARIETIES_LIST: 'VARIETIES/GET_VARIETIES_LIST',
  GET_VARIETIES_LIST_FAIL: 'VARIETIES/GET_VARIETIES_LIST_FAIL',

  GET_USED_VARIETIES_LIST_START: 'VARIETIES/GET_USED_VARIETIES_LIST_START',
  GET_USED_VARIETIES_LIST: 'VARIETIES/GET_USED_VARIETIES_LIST',
  GET_USED_VARIETIES_LIST_FAIL: 'VARIETIES/GET_USED_VARIETIES_LIST_FAIL',
};
